module.exports = __webpack_public_path__ + "static/media/winterweave-5.5f101c42.jpg";